import isCreditCard from 'validator/lib/isCreditCard'
import { extend, localize, setInteractionMode } from 'vee-validate'
import { email, max, min, numeric, oneOf, required } from 'vee-validate/dist/rules'
import en from '@/plugins/vee-validate/locale/en'

setInteractionMode('lazy')
localize('en', en)

extend('email', email)
extend('min', min)
extend('max', max)
extend('required', required)
extend('oneOf', oneOf)
extend('cvv', {
  validate: val => /^[0-9]{3,4}$/.test(String(val))
})
extend('credit_card', {
  validate: val => isCreditCard(String(val))
})
extend('numeric', numeric)
extend('expiration_date', {
  validate: ({ month, year }) => !!month && !!year
})
extend('array_max', {
  message: (_field, { size }: { size: number }) => `You can select maximum ${size} items`,
  validate: (value, { size }: { size: number }) => {
    if (!value || !value.length) {
      return true
    }

    return value.length <= size
  },
  params: ['size']
})
extend('array_min', {
  message: (field, { size }: { size: number }) => `Please select at least ${size} ${field}`,
  validate: (value, { size }: { size: number }) => {
    if (!value || !value.length) {
      return false
    }

    return value.length >= size
  },
  params: ['size']
})
extend('age', {
  message: (_field, { years }) => `You must be ${years} years old`,
  validate: (v, { years }: { years: number }) => {
    function _calculateAge(birthday) {
      const ageDate = new Date(Date.now() - birthday.getTime())
      return Math.abs(ageDate.getUTCFullYear() - 1970)
    }

    return _calculateAge(v) >= years
  },
  params: ['years']
})

extend('valid_phone', {
  message: () => 'Phone is not valid',
  validate: (value: boolean) => {
    return !value
  }
})

extend('date_input', {
  message: _field => `Please select ${_field.replace(/([A-Z])/g, ' $1').toLowerCase()}`,
  validate: (value) => {
    if (!value.month && !value.year) {
      return true
    }
    return !(!value.month || !value.year)
  }
})

extend('alpha_space_dash', {
  message: () => 'Please use only letters, spaces and dashes',
  validate: (value) => {
    return /^[A-Z\s_-]*$/i.test(value)
  }
})
